import { userInfoCommitComposable } from '@/composables';
import { queryParse } from 'cfmoto-utils';
import { Toast } from 'vant';
localStorage.removeItem('user_id');

export default [
  async (to, from, next) => {
    // sina非白名单复制链接参数处理
    if (/&amp%3B/.test(to.fullPath)) {
      const query = queryParse(to.fullPath.replace(/&amp%3B/g, '&'));
      next({ name: to.name, replace: true, query });
      return;
    }
    next();
  },
  async (to, from, next) => {
    if (!to.query.token) {
      next();
      return;
    }
    console.log('to:', to);
    // 去除授权参数
    const toQuery = JSON.parse(JSON.stringify({ ...to.query }));
    delete toQuery.token;
    next({ name: to.name, query: toQuery, params: to.params, replace: true });
  },
  async (to, from, next) => {
    const userInfo = await userInfoCommitComposable;
    if (to.meta.auth && !userInfo.id) {
      Toast('登录失效，请重新登录');
      return;
    }
    next();
  },
  async (to, from, next) => {
    console.log('beforeEach to:');
    console.log(to);
    next();
  },
];
